<template>
    <aside class="sidebar" :class="{active: showSidebar}">
        <div class="sidebar__inner">
            <div class="sidebar__content">
                <slot></slot>
            </div>
        </div>

        <div class="sidebar__logo">
            <a href="/">
                <slot name="logo"></slot>
            </a>
        </div>
    </aside>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component ({
        data() {
            return {
                showSidebar: false
            };
        },

        mounted() {
//            this.$eventHub.$on('showSidebar', () => {
//                this.showSidebar = !this.showSidebar;
//            });
        }
    })
    export default class Sidebar extends Vue {
        name = 'side-bar';
    }

    Vue.component('side-bar', Sidebar);
</script>


// WEBPACK FOOTER //
// src/components/general/Sidebar.vue